import { ViewContainerRef } from '@angular/core';
import { ITransactionOverride } from './transaction-override.interface';
import { SourceSystemType, ISourceSystemType } from '../../../foundation/models/enums/source-system-type.enum';
import { BusinessTransactionMetaData } from '../../models/business-transaction/business-transaction-metadata.model';

export abstract class TransactionOverrideService implements ITransactionOverride {
    private _viewContainerRef: ViewContainerRef;

    /**
     * Source system type enum
     */
    protected sourceSystemTypes: SourceSystemType = new SourceSystemType();

    /**
     * Gets the view container reference
     */
    public get ViewContainer(): ViewContainerRef {
        return this._viewContainerRef;
    }

    /**
     * Sets the view container reference
     */
    public set ViewContainer(viewContainerRef: ViewContainerRef) {
        this._viewContainerRef = viewContainerRef;
    }

    /**
     * Determines if the route should be overriden with a new business transaction.  If so, a new transaction
     * number will be passed back.  If the transaction should not be overridden, the original transaction number
     * will be returned.
     */
    public abstract getTransactionNumber(businessTransactionNumberId: number, metaData: BusinessTransactionMetaData): Promise<number>;

    /**
     * Returns the source system type for the transaction
     */
    public abstract get sourceSystemType(): ISourceSystemType;
}
